import {
  FREAK_TYPE_FREAK_HUB, STATUS_CANCELED, STATUS_FINISHED, STATUS_IN_PROGRESS, STATUS_PLANNED,
} from '../constants/commonConstants';
import {isFeed} from './freakUtils';

// who is looking at the freak details page; drives the top actions panel (mirrors mobile utils/freakActions.ts)
export const FREAK_VIEWER_ROLE = {
  OWNER: 'owner',
  PARTICIPANT: 'participant',
  REQUESTED: 'requested',
  INVITED: 'invited',
  DECLINED: 'declined',
  GUEST: 'guest',
  ANONYMOUS: 'anonymous',
};

export const FREAK_OWNER_ACTION = {
  START: 'start',
  FINISH: 'finish',
  EDIT: 'edit',
  MOVE: 'move',
  CANCEL: 'cancel',
  DELETE: 'delete',
};

export const getFreakViewerRole = (username, freak) => {
  if (!username) return FREAK_VIEWER_ROLE.ANONYMOUS;
  if (freak?.author?.username === username) return FREAK_VIEWER_ROLE.OWNER;

  const participant = freak?.participants?.find(p => p.username === username);
  switch (participant?.status) {
    case 'approved':
      return FREAK_VIEWER_ROLE.PARTICIPANT;
    case 'request_join':
      return FREAK_VIEWER_ROLE.REQUESTED;
    case 'pending':
      return FREAK_VIEWER_ROLE.INVITED;
    case 'declined':
      return FREAK_VIEWER_ROLE.DECLINED;
    default:
      return FREAK_VIEWER_ROLE.GUEST;
  }
};

// the API only accepts a join request from users who are not on the participants list yet
export const canRequestJoin = (role, freak) =>
  role === FREAK_VIEWER_ROLE.GUEST
  && !isFeed(freak)
  && (freak?.status === STATUS_PLANNED || freak?.status === STATUS_IN_PROGRESS);

// the one action that moves the freak forward, shown as the big button
export const getOwnerPrimaryAction = freak => {
  if (isFeed(freak)) return null;
  if (freak?.status === STATUS_PLANNED) return FREAK_OWNER_ACTION.START;
  if (freak?.status === STATUS_IN_PROGRESS) return FREAK_OWNER_ACTION.FINISH;
  return null;
};

export const getOwnerSecondaryActions = freak => {
  const actions = [];
  if (!isFeed(freak)) actions.push(FREAK_OWNER_ACTION.EDIT);
  // hub posts stay in their hub's context
  if (freak?.type !== FREAK_TYPE_FREAK_HUB && !freak?.freakHubId) actions.push(FREAK_OWNER_ACTION.MOVE);
  return actions;
};

// destructive actions live behind the "More" menu
export const getOwnerDangerActions = freak => {
  const actions = [];
  if (!isFeed(freak) && freak?.status === STATUS_PLANNED) actions.push(FREAK_OWNER_ACTION.CANCEL);
  if (freak?.status !== STATUS_IN_PROGRESS) actions.push(FREAK_OWNER_ACTION.DELETE);
  return actions;
};

export const countGoing = freak =>
  (freak?.participants || []).filter(p => p.status === 'approved').length + (freak?.author ? 1 : 0);

export const countJoinRequests = freak =>
  (freak?.participants || []).filter(p => p.status === 'request_join').length;

export const getStatusKey = status => {
  switch (status) {
    case STATUS_IN_PROGRESS:
      return 'inProgress';
    case STATUS_FINISHED:
      return 'finished';
    case STATUS_CANCELED:
      return 'canceled';
    case STATUS_PLANNED:
      return 'planned';
    default:
      return null;
  }
};

// {one, few, many} forms with Polish rules (English uses the same text for few and many)
export const pluralize = (forms, count) => {
  const mod10 = count % 10;
  const mod100 = count % 100;
  let form = forms.many;
  if (count === 1) form = forms.one;
  else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) form = forms.few;
  return form.replace('{count}', count);
};
